/**
 * @generated SignedSource<<e9e8c4729992a32310f4787dfbf095d9>>
 * @relayHash 181e900ed9b184b727eacc0e8e01751a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4d022230a6ccb1bba619a35fbd2eaf7a54075e73cab018187129e8a9f21a7060

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DevOpsMetricsResolutionUnit = "DAY" | "HOUR" | "WEEK" | "%future added value";
export type DevOpsMetricsRollupOption = "MEAN" | "PERCENTILE" | "%future added value";
export type DevOpsMetricsFilterInput = {
  cloudId: string;
  endAtExclusive: AGG$DateTime;
  issueFilters?: DevOpsMetricsIssueFilters | null | undefined;
  jiraProjectIds?: ReadonlyArray<string> | null | undefined;
  resolution?: DevOpsMetricsResolutionInput | null | undefined;
  startFromInclusive: AGG$DateTime;
  timezoneId?: string | null | undefined;
};
export type DevOpsMetricsIssueFilters = {
  epicIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  issueTypeIds?: ReadonlyArray<string> | null | undefined;
};
export type DevOpsMetricsResolutionInput = {
  unit: DevOpsMetricsResolutionUnit;
  value: number;
};
export type DevOpsMetricsRollupType = {
  percentile?: number | null | undefined;
  type: DevOpsMetricsRollupOption;
};
export type deploymentFrequencyCoreRelayQuery$variables = {
  deploymentFrequencyRollupType: DevOpsMetricsRollupType;
  deploymentSizeRollupType: DevOpsMetricsRollupType;
  filter: DevOpsMetricsFilterInput;
};
export type deploymentFrequencyCoreRelayQuery$data = {
  readonly devOpsMetrics: {
    readonly deploymentFrequencyDev: {
      readonly data: ReadonlyArray<{
        readonly count: number | null | undefined;
        readonly dateTime: AGG$DateTime | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly deploymentFrequencyProd: {
      readonly aggregateData: number | null | undefined;
      readonly data: ReadonlyArray<{
        readonly count: number | null | undefined;
        readonly dateTime: AGG$DateTime | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly deploymentFrequencyStg: {
      readonly data: ReadonlyArray<{
        readonly count: number | null | undefined;
        readonly dateTime: AGG$DateTime | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly deploymentFrequencyTesting: {
      readonly data: ReadonlyArray<{
        readonly count: number | null | undefined;
        readonly dateTime: AGG$DateTime | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly deploymentFrequencyUnmapped: {
      readonly data: ReadonlyArray<{
        readonly count: number | null | undefined;
        readonly dateTime: AGG$DateTime | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly deploymentSizeProd: {
      readonly aggregateData: number | null | undefined;
      readonly data: ReadonlyArray<{
        readonly dateTime: AGG$DateTime | null | undefined;
        readonly deploymentSize: number | null | undefined;
      } | null | undefined> | null | undefined;
    };
  };
};
export type deploymentFrequencyCoreRelayQuery = {
  response: deploymentFrequencyCoreRelayQuery$data;
  variables: deploymentFrequencyCoreRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deploymentFrequencyRollupType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deploymentSizeRollupType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v4 = {
  "kind": "Variable",
  "name": "rollupType",
  "variableName": "deploymentFrequencyRollupType"
},
v5 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v6 = {
  "concreteType": "DevOpsMetricsDeploymentFrequencyData",
  "kind": "LinkedField",
  "name": "data",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "count"
    }
  ]
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": "deploymentFrequencyDev",
  "args": [
    {
      "kind": "Literal",
      "name": "environmentCategory",
      "value": "DEVELOPMENT"
    },
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "concreteType": "DevOpsMetricsDeploymentFrequency",
  "kind": "LinkedField",
  "name": "deploymentFrequency",
  "plural": false,
  "selections": (v7/*: any*/)
},
v9 = {
  "alias": "deploymentFrequencyTesting",
  "args": [
    {
      "kind": "Literal",
      "name": "environmentCategory",
      "value": "TESTING"
    },
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "concreteType": "DevOpsMetricsDeploymentFrequency",
  "kind": "LinkedField",
  "name": "deploymentFrequency",
  "plural": false,
  "selections": (v7/*: any*/)
},
v10 = {
  "alias": "deploymentFrequencyStg",
  "args": [
    {
      "kind": "Literal",
      "name": "environmentCategory",
      "value": "STAGING"
    },
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "concreteType": "DevOpsMetricsDeploymentFrequency",
  "kind": "LinkedField",
  "name": "deploymentFrequency",
  "plural": false,
  "selections": (v7/*: any*/)
},
v11 = {
  "kind": "Literal",
  "name": "environmentCategory",
  "value": "PRODUCTION"
},
v12 = {
  "kind": "ScalarField",
  "name": "aggregateData"
},
v13 = {
  "alias": "deploymentFrequencyProd",
  "args": [
    (v11/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "concreteType": "DevOpsMetricsDeploymentFrequency",
  "kind": "LinkedField",
  "name": "deploymentFrequency",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v12/*: any*/)
  ]
},
v14 = {
  "alias": "deploymentFrequencyUnmapped",
  "args": [
    {
      "kind": "Literal",
      "name": "environmentCategory",
      "value": "UNMAPPED"
    },
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "concreteType": "DevOpsMetricsDeploymentFrequency",
  "kind": "LinkedField",
  "name": "deploymentFrequency",
  "plural": false,
  "selections": (v7/*: any*/)
},
v15 = {
  "alias": "deploymentSizeProd",
  "args": [
    (v11/*: any*/),
    (v3/*: any*/),
    {
      "kind": "Variable",
      "name": "rollupType",
      "variableName": "deploymentSizeRollupType"
    }
  ],
  "concreteType": "DevOpsMetricsDeploymentSize",
  "kind": "LinkedField",
  "name": "deploymentSize",
  "plural": false,
  "selections": [
    {
      "concreteType": "DevOpsMetricsDeploymentSizeData",
      "kind": "LinkedField",
      "name": "data",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "deploymentSize"
        }
      ]
    },
    (v12/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "deploymentFrequencyCoreRelayQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "DevOpsMetrics",
          "kind": "LinkedField",
          "name": "devOpsMetrics",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v8/*: any*/),
              "action": "THROW",
              "path": "devOpsMetrics.deploymentFrequencyDev"
            },
            {
              "kind": "RequiredField",
              "field": (v9/*: any*/),
              "action": "THROW",
              "path": "devOpsMetrics.deploymentFrequencyTesting"
            },
            {
              "kind": "RequiredField",
              "field": (v10/*: any*/),
              "action": "THROW",
              "path": "devOpsMetrics.deploymentFrequencyStg"
            },
            {
              "kind": "RequiredField",
              "field": (v13/*: any*/),
              "action": "THROW",
              "path": "devOpsMetrics.deploymentFrequencyProd"
            },
            {
              "kind": "RequiredField",
              "field": (v14/*: any*/),
              "action": "THROW",
              "path": "devOpsMetrics.deploymentFrequencyUnmapped"
            },
            {
              "kind": "RequiredField",
              "field": (v15/*: any*/),
              "action": "THROW",
              "path": "devOpsMetrics.deploymentSizeProd"
            }
          ]
        },
        "action": "THROW",
        "path": "devOpsMetrics"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "deploymentFrequencyCoreRelayQuery",
    "selections": [
      {
        "concreteType": "DevOpsMetrics",
        "kind": "LinkedField",
        "name": "devOpsMetrics",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "4d022230a6ccb1bba619a35fbd2eaf7a54075e73cab018187129e8a9f21a7060",
    "metadata": {},
    "name": "deploymentFrequencyCoreRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "420efc85afb618301c4c9a412536d149";

export default node;
